<div class="pagination">
  <div class="pagination-left">
    @if (totalSelected() > 0) {
      <div class="selection-info">
        <span class="selection-count">{{ totalSelected() }} selected</span>
        <button class="clear-selection-btn" (click)="clearSelection.emit()">Clear</button>
      </div>
    } @else {
      <div class="page-size-selector">
        <span class="page-size-label">Show</span>
        <select class="page-size-select" [value]="pageSize()" (change)="onPageSizeChange($event)">
          @for (option of pageSizeOptions(); track option) {
            <option [value]="option">{{ option }}</option>
          }
        </select>
        <span class="page-size-label">{{ itemName() }}</span>
      </div>
    }
  </div>

  <div class="pagination-right">
    <span class="pagination-info">
      Showing {{ showingFrom() }}-{{ showingTo() }} of {{ totalItems() | number }} {{ itemName() }}
    </span>

    <div class="pagination-controls">
      <!-- First Page -->
      <button
        class="page-btn"
        [disabled]="currentPage() === 1"
        (click)="onPageChange(1)"
        title="First Page"
      >
        <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 19l-7-7 7-7m8 14l-7-7 7-7"
          />
        </svg>
      </button>

      <!-- Previous Page -->
      <button
        class="page-btn"
        [disabled]="currentPage() === 1"
        (click)="onPageChange(currentPage() - 1)"
        title="Previous Page"
      >
        <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </button>

      <!-- Page Numbers -->
      @for (page of pages(); track $index) {
        @if (isNumber(page)) {
          <button
            class="page-btn"
            [class.active]="page === currentPage()"
            (click)="onPageChange(page)"
          >
            {{ page }}
          </button>
        } @else {
          <span class="page-dots">{{ page }}</span>
        }
      }

      <!-- Next Page -->
      <button
        class="page-btn"
        [disabled]="currentPage() === totalPages() || totalPages() === 0"
        (click)="onPageChange(currentPage() + 1)"
        title="Next Page"
      >
        <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        </svg>
      </button>

      <!-- Last Page -->
      <button
        class="page-btn"
        [disabled]="currentPage() === totalPages() || totalPages() === 0"
        (click)="onPageChange(totalPages())"
        title="Last Page"
      >
        <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13 5l7 7-7 7M5 5l7 7-7 7"
          />
        </svg>
      </button>
    </div>
  </div>
</div>
